import type { PropsWithChildren } from "react";

export const Menu = ({ children }: PropsWithChildren) => {
  return (
    <div className="flex min-h-screen flex-1 flex-col bg-text-primary">
      {children}
    </div>
  );
};
